import React from "react";
import "../../legal/PrivacyPolicy/PrivacyPolicy.css";

const PressMedia = () => {
  return (
    <div className="legal-page">
      {/* Hero Section */}
      <section className="legal-hero">
        <div className="container">
          <h1>Press & Media</h1>
          <p className="legal-subtitle">
            News, updates, and media resources about GoalFlex.
          </p>
        </div>
      </section>

      {/* Content Section */}
      <section className="legal-content">
        <div className="container">
          <div className="legal-intro">
            <p>
              Welcome to the GoalFlex press center. Here you'll find the latest
              news, company information, high-resolution assets, and resources
              for journalists, bloggers, and media professionals covering the
              sports technology and soccer community space.
            </p>
          </div>

          <div className="legal-section">
            <h2>Latest News & Updates</h2>
            <div className="subsection">
              <h3>January 2025 - Platform Launch</h3>
              <p>
                GoalFlex officially launches in the Twin Cities metro area,
                starting with Minneapolis and St. Paul. The platform begins
                connecting local soccer players with a focus on building
                inclusive community connections.
              </p>
            </div>
            <div className="subsection">
              <h3>December 2024 - Community Building</h3>
              <p>
                GoalFlex reaches its first milestone of 500+ registered players
                in Minnesota. The platform successfully facilitates 25+ games
                per week, fostering connections across diverse skill levels and
                backgrounds.
              </p>
            </div>
            <div className="subsection">
              <h3>November 2024 - Beta Testing</h3>
              <p>
                Successful completion of beta testing phase with local soccer
                enthusiasts. Launch of mobile app with smart matching features
                and enhanced safety protocols for the Minnesota soccer
                community.
              </p>
            </div>
          </div>

          <div className="legal-section">
            <h2>Company Information</h2>
            <div className="subsection">
              <h3>About GoalFlex</h3>
              <p>
                GoalFlex is a Minnesota-based startup connecting local soccer
                players across the Twin Cities metro area. Founded in 2024,
                we're building inclusive communities where players of all skill
                levels can connect and play together.
              </p>
            </div>
            <div className="subsection">
              <h3>Mission Statement</h3>
              <p>
                To make soccer accessible to everyone by creating inclusive
                communities where players of all skill levels can connect, play,
                and grow together.
              </p>
            </div>
            <div className="subsection">
              <h3>Key Statistics</h3>
              <ul>
                <li>
                  <strong>500+</strong> Active Players
                </li>
                <li>
                  <strong>Minnesota</strong> Service Area (expanding)
                </li>
                <li>
                  <strong>25+</strong> Weekly Games
                </li>
                <li>
                  <strong>95%</strong> User Satisfaction Rate
                </li>
                <li>
                  <strong>Founded:</strong> 2024
                </li>
                <li>
                  <strong>Headquarters:</strong> San Francisco, CA
                </li>
              </ul>
            </div>
          </div>

          <div className="legal-section">
            <h2>Media Kit & Assets</h2>
            <div className="subsection">
              <h3>Logos & Branding</h3>
              <p>
                Download high-resolution GoalFlex logos, brand guidelines, and
                visual assets for use in articles, presentations, and media
                coverage.
              </p>
              <ul>
                <li>GoalFlex Logo (PNG, SVG, PDF formats)</li>
                <li>Brand Color Palette</li>
                <li>Typography Guidelines</li>
                <li>Usage Guidelines and Restrictions</li>
              </ul>
            </div>
            <div className="subsection">
              <h3>Photography</h3>
              <p>
                Professional photos of GoalFlex in action, including game
                scenes, player interactions, and platform screenshots.
              </p>
              <ul>
                <li>Game Action Photos</li>
                <li>Community Events</li>
                <li>App Screenshots</li>
                <li>Team Photos</li>
              </ul>
            </div>
            <div className="subsection">
              <h3>Video Content</h3>
              <ul>
                <li>Platform Demo Videos</li>
                <li>Player Testimonials</li>
                <li>Community Highlights</li>
                <li>Founder Interviews</li>
              </ul>
            </div>
          </div>

          <div className="legal-section">
            <h2>Executive Team</h2>
            <div className="subsection">
              <h3>Leadership Bios</h3>
              <p>
                Meet the team behind GoalFlex's vision of connecting soccer
                communities worldwide.
              </p>
              <ul>
                <li>
                  <strong>CEO & Founder:</strong> Available for interviews and
                  speaking opportunities
                </li>
                <li>
                  <strong>CTO:</strong> Technology and platform development
                  insights
                </li>
                <li>
                  <strong>Head of Community:</strong> User experience and
                  community growth
                </li>
                <li>
                  <strong>Head of Partnerships:</strong> Business development
                  and venue relations
                </li>
              </ul>
            </div>
          </div>

          <div className="legal-section">
            <h2>Awards & Recognition</h2>
            <ul>
              <li>
                <strong>2025 Sports Tech Innovation Award</strong> - Best
                Community Platform
              </li>
              <li>
                <strong>App Store Feature</strong> - "App of the Day"
                recognition
              </li>
              <li>
                <strong>Soccer Industry Awards</strong> - Rising Star Company
              </li>
              <li>
                <strong>TechCrunch</strong> - Featured startup spotlight
              </li>
            </ul>
          </div>

          <div className="legal-section">
            <h2>Media Coverage</h2>
            <div className="subsection">
              <h3>Recent Articles</h3>
              <ul>
                <li>
                  <strong>TechCrunch:</strong> "How GoalFlex is Revolutionizing
                  Pickup Soccer"
                </li>
                <li>
                  <strong>Sports Business Journal:</strong> "The Future of
                  Community Sports Platforms"
                </li>
                <li>
                  <strong>Forbes:</strong> "5 Sports Tech Startups to Watch in
                  2025"
                </li>
                <li>
                  <strong>ESPN:</strong> "Technology Meets Grassroots Soccer"
                </li>
              </ul>
            </div>
          </div>

          <div className="legal-section">
            <h2>Interview Opportunities</h2>
            <p>
              Our leadership team is available for interviews, podcast
              appearances, and speaking engagements on topics including:
            </p>
            <ul>
              <li>Sports technology and innovation</li>
              <li>Community building in sports</li>
              <li>Startup growth and scaling</li>
              <li>The future of recreational sports</li>
              <li>Soccer culture and accessibility</li>
            </ul>
          </div>

          <div className="legal-section">
            <h2>Press Inquiries</h2>
            <div className="contact-info">
              <p>
                <strong>Press Contact:</strong>{" "}
                <a href="mailto:press@goalflex.com">press@goalflex.com</a>
              </p>
              <p>
                <strong>Media Relations:</strong>{" "}
                <a href="mailto:media@goalflex.com">media@goalflex.com</a>
              </p>
              <p>
                <strong>Interview Requests:</strong>{" "}
                <a href="mailto:interviews@goalflex.com">
                  interviews@goalflex.com
                </a>
              </p>
              <p>
                <strong>Response Time:</strong> We respond to all media
                inquiries within 24 hours
              </p>
              <p>
                <strong>Media Kit Download:</strong>{" "}
                <a href="mailto:press@goalflex.com?subject=Media Kit Request">
                  Request Full Media Kit
                </a>
              </p>
            </div>
          </div>

          <div className="legal-section">
            <h2>Usage Guidelines</h2>
            <p>
              When covering GoalFlex in your publication or media outlet,
              please:
            </p>
            <ul>
              <li>Use official logos and brand assets from our media kit</li>
              <li>Refer to us as "GoalFlex" (not "Goal Flex" or "goalflex")</li>
              <li>Include accurate statistics and company information</li>
              <li>Reach out for fact-checking and quote verification</li>
              <li>Provide us with publication links when articles go live</li>
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PressMedia;
